const THREE = require("three");
var store = require("../data/store.js");
var GEOS = require("./geos.js");
const config = require("../config.js");
const UTILS = require("./utils.js");
var v9350 = new THREE.Vector3();
var v9351 = GEOS.generateCube(null, 1, 1, 1, {});
var v9352 = GEOS.generateCylinder(0, 0, 0, {
  sides: 5
});
function f1501(RENDER) {
  this.mesh = new THREE.Mesh(v9352);
  this.init = function (p11951, p11952, p11953, p11954) {
    this.scale = 0.3;
    this.mesh.material = RENDER.getMat("default", {
      mat: THREE.MeshBasicMaterial,
      forceMat: THREE.MeshBasicMaterial,
      color: RENDER.ropeColor || 11776947
    });
    this.x = p11952;
    this.y = p11953;
    this.z = p11954;
    this.parent = p11951;
    RENDER.moveMesh(this.mesh, p11952, p11953, p11954);
    this.updateMesh();
  };
  this.update = function () {
    if (this.mesh.visible) {
      if (this.parent && this.parent.active && this.parent.grapple) {
        this.updateMesh();
        return;
      } else {
        this.mesh.visible = false;
        return;
      }
    } else {
      return undefined;
    }
  };
  let v9353 = new THREE.Vector3();
  this.updateMesh = function () {
    if (this.parent) {
      var v9354;
      var v9355;
      var v9356;
      if (this.parent.weaponMeshes && this.parent.weaponMeshes[this.parent.loadoutIndex] && this.parent.weaponMeshes[this.parent.loadoutIndex].muzzles) {
        this.parent.weaponMeshes[this.parent.loadoutIndex].muzzles[0].getWorldPosition(v9353);
        v9354 = v9353.x;
        v9355 = v9353.y;
        v9356 = v9353.z;
      } else {
        v9354 = this.parent.x;
        v9355 = this.parent.y + (this.parent.height || 0) / 2;
        v9356 = this.parent.z;
      }
      var v9357 = UTILS.getD3D(this.x, this.y, this.z, v9354, v9355, v9356);
      this.mesh.lookAt(v9354, v9355, v9356);
      this.mesh.rotateX(Math.PI / 2);
      RENDER.scaleMesh(this.mesh, this.scale, v9357, this.scale);
      this.mesh.visible = true;
    }
  };
}
function f1502(RENDER, p11956) {
  var v9358 = p11956 == 2 ? "trails/0" : null;
  this.meshConf = {
    src: null
  };
  if (v9358) {
    this.meshConf = {
      src: v9358,
      color: "#ef9ff2",
      mat: THREE.MeshBasicMaterial,
      noFog: true,
      transparent: true,
      depthWrite: false,
      alphaTest: 0.05,
      blending: 2,
      side: 2
    };
  }
  if (this.meshConf.src) {
    this.mesh = RENDER.genObj3D(0, 0, 0);
    RENDER.loadMesh(this.meshConf, 0, 0, 0, 0, 1, this.mesh);
  } else {
    this.mesh = new THREE.Mesh(v9351);
  }
  this.tType = p11956;
  this.init = function (p11957) {
    this.dst = p11957.dst / 2;
    this.spd = p11957.spd;
    this.xS = p11957.xS;
    this.zS = p11957.zS;
    this.yS = p11957.yS;
    this.scale = p11956 == 2 ? 6 : 0.45;
    this.sclSpd = p11956 == 2 ? 0.016 : 0.00036;
    this.len = 0;
    if (!this.meshConf.src) {
      this.mesh.material = RENDER.getMat("default", {
        mat: THREE.MeshBasicMaterial,
        forceMat: THREE.MeshBasicMaterial,
        color: RENDER.trailColor || 15592941,
        transparent: true,
        opacity: 0.18
      });
    }
    var v9359 = p11957.mesh.position.x;
    var v9360 = p11957.mesh.position.y;
    var v9361 = p11957.mesh.position.z;
    RENDER.moveMesh(this.mesh, v9359, v9360, v9361);
    this.mesh.lookAt(v9359 + this.xS, v9360 + this.yS, v9361 + this.zS);
    this.mesh.rotateX(Math.PI / 2);
    RENDER.scaleMesh(this.mesh, this.scale, this.dst, this.scale);
    this.mesh.visible = true;
  };
  this.update = function (p11958) {
    if (this.mesh.visible) {
      if (this.len < this.dst) {
        this.len += this.spd * p11958;
        if (this.len >= this.dst) {
          this.len = this.dst;
        }
      }
      this.scale -= this.sclSpd * p11958;
      RENDER.scaleMesh(this.mesh, this.scale, this.len, this.scale);
      if (this.scale <= 0) {
        this.scale = 0;
        this.mesh.visible = false;
      }
    }
  };
}
class C281 extends THREE.Object3D {
  constructor() {
    super();
    this.largeSpawnCount = 8;
    this.smallSpawnCount = 15;
    this.emissiveness = 0.55;
    this.velocityDamping = 3;
    this.lifeSpeedMin = 2.2;
    this.lifeSpeedRange = 3;
    this.totalParticles = 200;
    this.particleIndex = 0;
    var v9362 = new THREE.Color(12303291);
    let v9363 = new THREE.BoxGeometry(1, 1, 1);
    v9363.computeVertexNormals();
    this.mesh = new THREE.InstancedMesh(v9363, new THREE.StrippedLambertMaterial({
      color: v9362,
      emissive: v9362.multiplyScalar(this.emissiveness),
      flatShading: false
    }), this.totalParticles);
    this.mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
    this.mesh.castShadow = true;
    this.mesh.receiveShadow = true;
    this.add(this.mesh);
    this.entities = [];
    this.entitiesToDelete = [];
    this.mesh.count = 0;
  }
  finished() {
    return this.entities.length === 0;
  }
  explodeAt(p11959, p11960, p11961, p11962, p11963, p11964) {
    this.sizeMin = p11962 * 0.35;
    this.sizeRange = p11962 * 1.8;
    this.velocityMin = p11962 * 30;
    this.velocityRange = p11962 * 17;
    v9350.set(p11959, p11960, p11961);
    p11964 = p11964 == null ? this.largeSpawnCount : p11964 || 0;
    p11963 = p11963 == null ? this.smallSpawnCount : p11963 || 0;
    this.spawning = true;
    for (var vLN01516 = 0; vLN01516 < p11964; vLN01516++) {
      this.spawnEntity(Math.random() * 0.1 + 0.9, v9350, false);
    }
    for (var vLN01516 = 0; vLN01516 < p11963; vLN01516++) {
      this.spawnEntity(Math.random() * 0.9, v9350, false);
    }
    this.spawning = false;
  }
  spawnEntity(p11965, p11966) {
    var v9364 = Math.pow(p11965, 2.5);
    var v9365 = v9364 * this.sizeRange + this.sizeMin;
    var v9366 = (1 - v9364) * this.velocityRange + this.velocityMin;
    var v9367 = function () {
      return new THREE.Vector3(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5);
    }().normalize().multiplyScalar(v9366);
    var v9368 = v9364 * this.lifeSpeedRange + this.lifeSpeedMin;
    let v9369 = this.particleIndex % this.totalParticles;
    this.entities[v9369] = {
      index: 0,
      rank: v9364,
      rankSeed: p11965,
      life: 0,
      lifeSpeed: v9368,
      size: v9365,
      scale: 1,
      position: p11966.clone(),
      velocity: v9367,
      matrix: new THREE.Matrix4()
    };
    this.particleIndex++;
    this.mesh.count = Math.min(this.particleIndex, this.totalParticles);
  }
  update(p11967) {
    p11967 /= 1000;
    var v9370;
    for (var vLN01517 = 0; vLN01517 < Math.min(this.particleIndex, this.totalParticles); vLN01517++) {
      v9370 = this.entities[vLN01517];
      v9370.life += p11967 * v9370.lifeSpeed;
      v9370.velocity.multiplyScalar(1 - this.velocityDamping * p11967);
      v9370.position.add(v9370.velocity.clone().multiplyScalar(p11967));
      var v9371 = -Math.pow(v9370.life / Math.sqrt(2), 2) + 2;
      v9371 *= v9370.size;
      v9370.scale = v9371;
      if (v9371 < 0) {
        v9371 = 0;
      }
      v9370.matrix.makeScale(v9371, v9371, v9371);
      v9370.matrix.setPosition(v9370.position.x, v9370.position.y, v9370.position.z);
      this.mesh.setMatrixAt(vLN01517, v9370.matrix);
    }
    this.mesh.instanceMatrix.needsUpdate = true;
  }
}
var vA520 = [{
  rng: 27,
  src: ["whizz_0", "whizz_1"],
  vol: 0.12
}];
var vA521 = [{
  mat: THREE.MeshBasicMaterial,
  snd: 0,
  spd: 1.7,
  scale: 1,
  length: 13,
  color: 16777179
}, {
  spd: [0.03, 0.031],
  rand: true,
  carryV: true,
  grav: 0.0003,
  spn: [0.04, 0.05],
  scale: 0.15,
  length: 0.5,
  color: 10124094
}, {
  spd: [0.03, 0.031],
  rand: true,
  carryV: true,
  grav: 0.0003,
  spn: [0.03, 0.05],
  scale: 0.1,
  length: 0.4,
  color: 10124094
}];
function f1503(RENDER, p11969, p11970) {
  p11969 = p11969 || {};
  p11970 = p11970 || {};
  var v9372 = p11970 && p11970.s ? p11970.s : p11969 ? p11969.s : undefined;
  var v9373 = p11970 ? p11970.rot : undefined;
  this.meshConf = {
    src: null
  };
  if (v9372 != null) {
    if (UTILS.isNumber(v9372)) {
      this.meshConf = UTILS.getMeleeConfig(v9372, store, THREE);
    } else {
      var v9374 = (p11969.pjA || "").includes("g");
      var v9375 = (p11969.pjA || "").includes("q");
      var v9376 = (p11969.pjA || "").includes("f");
      this.meshConf = {
        fileExt: v9375 ? "glb" : v9374 ? "gltf" : v9376 ? "fbx" : null,
        hasAnim: !!v9374 || !!v9375 || !!v9376,
        src: v9372,
        asset: p11969.pjA,
        emissive: p11969.emis || null,
        noFog: true,
        transparent: !!p11969.pjT,
        depthWrite: p11970.depthW == null ? !!p11969.pjA : p11970.depthW,
        blending: p11970.blend == null ? p11969.pjA && !p11969.pjGl ? 0 : 2 : p11970.blend,
        side: 2
      };
    }
  }
  if (this.meshConf.src) {
    this.mesh = RENDER.genObj3D(0, 0, 0);
    RENDER[this.meshConf.hasAnim ? "loadAnimMesh" : "loadMesh"](this.meshConf, 0, 0, 0, v9373 == null ? Math.PI / 2 : v9373, 1, this.mesh);
  } else {
    this.mesh = new THREE.Mesh(RENDER.cubeGeo);
  }
  this.init = function (p11971, p11972, p11973, p11974, p11975, p11976, p11977, p11978, p11979) {
    this.dst = p11976;
    this.scale = p11977.scale * (p11979 ? p11979.pjSC || 1 : 1);
    var v9377 = p11979 ? p11979.v || 1 : 1;
    this.spd = (p11977.spd[1] ? UTILS.randFloat(p11977.spd[0], p11977.spd[1]) : p11977.spd) * v9377;
    this.spd *= p11979 && p11979.pjSp != null ? p11979.pjSp : 1;
    var v9378 = p11977 && p11977.carryV && p11978;
    p11974 -= Math.PI;
    this.xS = this.spd * Math.sin(p11974) * Math.cos(p11975) + (v9378 ? p11978.velocity.x : 0);
    this.zS = this.spd * Math.cos(p11974) * Math.cos(p11975) + (v9378 ? p11978.velocity.z : 0);
    this.yS = this.spd * Math.sin(p11975) + (v9378 ? p11978.velocity.y : 0);
    this.grav = p11979 && p11979.pjG != null ? p11979.pjG : p11977.grav;
    this.lingerTime = p11977.linger;
    this.lookDir = !!p11977.lookDir;
    this.spin = (p11977.spn ? p11977.spn[1] ? UTILS.randFloat(p11977.spn[0], p11977.spn[1]) : p11977.spn : 0) * v9377 * (p11979 && p11979.pjS != null ? p11979.pjS || 0 : 1);
    this.spinDir = (p11977.spnD || "x").toUpperCase();
    this.sound = p11978 && p11978.isYou && p11977.snd != null ? null : vA520[p11977.snd];
    this.soundPlayed = false;
    if (!this.meshConf.src) {
      if (p11977.mat == "BASIC" || p11977.mat == THREE.MeshBasicMaterial) {
        p11977.mat = THREE.MeshBasicMaterial;
        p11977.forceMat = THREE.MeshBasicMaterial;
      }
      this.mesh.receiveShadow = p11977.mat != THREE.MeshBasicMaterial;
      this.mesh.material = RENDER.getMat("default", {
        fog: p11977.mat != THREE.MeshBasicMaterial,
        color: p11977.color,
        emissive: p11977.emis,
        mat: p11977.mat,
        forceMat: p11977.forceMat,
        vertexColors: false
      });
    }
    this.layer = p11978 && p11978.renderYou ? 1 : 0;
    RENDER.moveMesh(this.mesh, p11971, p11972, p11973);
    if (!p11977 || !p11977.noLookAt) {
      this.mesh.lookAt(p11971 + this.xS, p11972 + this.yS, p11973 + this.zS);
    }
    if (p11977 && p11977.rand) {
      this.mesh.rotateX(UTILS.randFloat(-Math.PI, Math.PI));
    }
    if (!p11979 || !p11979.pjA) {
      var v9380 = (p11979 && p11979.pjMS ? p11979.pjMS || 1 : 1) * (p11977.scaleMlt || 1);
      RENDER.scaleMesh(this.mesh, p11977.scale * v9380, p11977.scale * v9380, p11977.length * v9380);
    } else if (p11979) {
      var v9380 = (p11979.pjSC || 1) * (p11979.pjMS || 1);
      RENDER.scaleMesh(this.mesh, v9380, v9380, v9380);
    }
  };
  this.checkSound = function () {
    if (this.sound && !this.soundPlayed) {
      var v9381 = Howler.pos();
      var v9382 = UTILS.getD3D(v9381[0], v9381[1], v9381[2], this.mesh.position.x, this.mesh.position.y, this.mesh.position.z);
      if (v9382 <= this.sound.rng) {
        SOUND.play(this.sound.src[UTILS.randInt(0, this.sound.src.length - 1)], this.sound.vol, false, UTILS.randFloat(0.8, 1.2));
        this.soundPlayed = true;
      }
    }
  };
  this.update = function (p11980) {
    if (this.mesh.visible) {
      if (this.linger > 0) {
        this.linger -= p11980;
        if (this.linger <= 0) {
          this.mesh.visible = false;
        }
      } else {
        this.mesh.position.x += this.xS * p11980;
        this.mesh.position.z += this.zS * p11980;
        this.mesh.position.y += this.yS * p11980;
        if (this.spin) {
          this.mesh["rotate" + this.spinDir](this.spin * p11980);
        }
        if (this.grav) {
          this.yS -= (this.grav || 0) * p11980;
          if (this.lookDir) {
            this.mesh.lookAt(this.mesh.position.x + this.xS, this.mesh.position.y + this.yS, this.mesh.position.z + this.zS);
          }
        }
        this.dst -= this.spd * p11980;
        this.checkSound();
        if (this.dst <= 0) {
          this.mesh.visible = false;
        }
      }
    }
  };
}
THREE.Sprite.prototype.init = function (p11981, p11982, p11983, p11984, p11985) {
  this.position.x = p11981;
  this.position.y = p11982;
  this.position.z = p11983;
  this.xVel = p11984.xV || 0;
  this.yVel = p11984.yV || 0;
  this.oYVel = this.yVel;
  this.zVel = p11984.zV || 0;
  this.startSiz = p11984.siz || 0;
  this.scale.x = this.scale.y = this.startSiz;
  this.sclSpd = p11984.scl || 0;
  this.life = p11984.life || 0;
  this.decl = p11984.decl || 0;
  this.grav = p11984.grav || 0;
  this.static = p11984.static;
  this.dstVis = p11984.dstVis || 0;
  this.visCountD = 0;
  this.area = p11985;
  this.updC = 0;
};
THREE.Sprite.prototype.update = function (p11986, p11987, p11988, p11989) {
  if (!p11987) {
    this.visible = false;
    return;
  }
  if ((this.area || this.dstVis) && (this.visCountD -= p11986, this.visCountD <= 0)) {
    var v9383 = UTILS.getD3D(p11988 ? p11988.x : 0, p11988 ? p11988.y : 0, p11988 ? p11988.z : 0, this.position.x, this.position.y, this.position.z);
    this.visCountD = v9383 >= 2000 ? UTILS.randInt(5000, 7000) : v9383 >= 1000 ? UTILS.randInt(1500, 2500) : v9383 >= 400 ? UTILS.randInt(1000, 1200) : UTILS.randInt(500, 600);
    this.visible = v9383 <= p11989 * (this.dstVis || 1);
  }
  if (this.visible || this.area) {
    this.position.x += this.xVel * p11986;
    this.position.z += this.zVel * p11986;
    this.position.y += this.yVel * p11986;
    this.yVel -= this.grav * p11986;
    if (this.area) {
      var v9384 = this.scale.x / 2;
      if (this.position.x - v9384 >= this.area.x + this.area.w) {
        this.position.x = this.area.x - this.area.w - v9384;
      } else if (this.position.x + v9384 <= this.area.x - this.area.w) {
        this.position.x = this.area.x + this.area.w + v9384;
      }
      if (this.position.z - v9384 >= this.area.z + this.area.l) {
        this.position.z = this.area.z - this.area.l - v9384;
      } else if (this.position.z + v9384 <= this.area.z - this.area.l) {
        this.position.z = this.area.z + this.area.l + v9384;
      }
      if (this.position.y - v9384 > this.area.y + this.area.h) {
        this.position.y = this.area.y - v9384;
        this.yVel = this.oYVel;
        this.visible = false;
      } else if (this.position.y + v9384 < this.area.y) {
        this.position.y = this.area.y + this.area.h + v9384;
        this.yVel = this.oYVel;
        this.visible = false;
      }
    }
    if (this.life > 0) {
      this.life -= p11986;
      if (this.life <= 0 && this.updC) {
        this.visible = false;
      }
      this.updC++;
    } else if (this.life <= 0 && this.updC) {
      this.visible = false;
    }
  }
};
var vA522 = [Math.PI / 3, -Math.PI / 3];
var vA523 = [{
  src: "0",
  hole: true,
  count: 2,
  grav: -0.00002,
  scale: [5, 9],
  speed: [0, 0.025],
  spread: [-0.4, 0.4],
  life: [300, 500]
}, {}, {
  count: 1,
  blending: 2,
  scale: [5, 7],
  speed: [0, 0],
  spread: [0, 0],
  life: [30, 35]
}, {
  count: 1,
  blending: 2,
  scale: [2000, 2000],
  speed: [0, 0],
  spread: [0, 0]
}, {
  count: 4,
  src: "0",
  scale: [5, 6],
  speed: [0, 0.01],
  spread: [-1, 1],
  life: [600, 800]
}, {
  src: "feather",
  count: 1,
  grav: 0,
  scale: [2, 3],
  speed: [0.005, 0.007],
  dstVis: 70,
  colr: ["#764CAD", "#ffffc2", "#51ff99", "#ffa0b3"],
  spread: [-Math.PI, Math.PI],
  life: [1000, 1800]
}, {
  src: "glow_0",
  count: 2,
  blending: 2,
  grav: 0,
  scale: [0.5, 0.8],
  speed: [0.005, 0.007],
  dstVis: 70,
  colr: ["#ffd666", "#ffbd66"],
  spread: [-Math.PI, Math.PI],
  life: [1000, 1800]
}, {
  src: "star_0",
  count: 5,
  blending: 2,
  grav: 0,
  scale: [0.2, 1],
  speed: [0.005, 0.007],
  dstVis: 70,
  colr: ["#0A0068", "#26007B", "#42008D", "#5E00A0", "#7A00B2", "#ffffff", "#000000"],
  spread: [-Math.PI, Math.PI],
  life: [1000, 1800]
}];
module.exports = function (RENDER) {
  var v9385;
  var v9386;
  var v9387;
  var v9388;
  var vThis94 = this;
  this.particles = [];
  this.trails = [];
  this.ropes = [];
  this.physObjs = [];
  this.areas = [];
  this.active = true;
  this.partDst = 160;
  this.ExplosionManager = new C281();
  this.showMuzzle = true;
  this.showCasings = true;
  this.showImpactHoles = true;
  this.addRope = function (p11991, p11992, p11993, p11994) {
    v9388 = null;
    for (var vLN01518 = 0; vLN01518 < this.ropes.length; ++vLN01518) {
      if (!this.ropes[vLN01518].mesh.visible || this.ropes[vLN01518].parent == p11991) {
        v9388 = this.ropes[vLN01518];
        break;
      }
    }
    if (!v9388) {
      v9388 = new f1501(RENDER);
      this.ropes.push(v9388);
      RENDER.scene.add(v9388.mesh);
    }
    v9388.init(p11991, p11992, p11993, p11994);
  };
  this.addTrail = function (p11995, p11996) {
    v9387 = null;
    for (var vLN01519 = 0; vLN01519 < this.trails.length; ++vLN01519) {
      if (!this.trails[vLN01519].mesh.visible && this.trails[vLN01519].tType == p11996) {
        v9387 = this.trails[vLN01519];
        break;
      }
    }
    if (!v9387) {
      v9387 = new f1502(RENDER, p11996);
      this.trails.push(v9387);
      RENDER.scene.add(v9387.mesh);
    }
    v9387.init(p11995);
  };
  this.area = function (p11997, p11998, p11999, p12000, p12001, p12002, p12003, p12004) {
    p12000 /= 2;
    p12002 /= 2;
    vThis94.areas.push({
      f: p12004,
      x: p11997,
      y: p11998,
      z: p11999,
      w: p12000,
      h: p12001,
      l: p12002
    });
    var v9389 = p12003.spd * 0.005;
    var v9390 = ((p12003.dir || 0) + 1) * Math.PI / 2 - Math.PI / 2;
    var v9391 = config.particleIDS[p12003.txt || 0] || "default";
    if (v9391 != "default") {
      v9391 += "_0";
    }
    for (var vLN01520 = 0; vLN01520 < p12003.cnt; ++vLN01520) {
      vThis94.add(p11997 + UTILS.randInt(-p12000, p12000), p11998 + UTILS.randInt(0, p12001), p11999 + UTILS.randInt(-p12002, p12002), {
        src: v9391,
        cnt: p12003.cnt,
        static: true,
        xV: v9389 * Math.cos(v9390),
        zV: v9389 * Math.sin(v9390),
        grav: (p12003.grav || 0) * (UTILS.randFloat(0.7, 1.3) * 0.00001),
        decl: p12003.decl,
        scl: p12003.scl * UTILS.randFloat(0.75, 1.25),
        siz: p12003.siz,
        colr: p12003.colr,
        blend: p12003.blend
      }, this.areas[this.areas.length - 1]);
    }
  };
  this.effect = function (p12005, p12006, p12007, p12008, p12009, p12010, p12011) {
    if (vThis94.active) {
      v9385 = vA523[p12010];
      for (var vLN01521 = 0; vLN01521 < v9385.count; ++vLN01521) {
        var v9392 = UTILS.randFloat(v9385.speed[0], v9385.speed[1]);
        var v9393 = p12008 + UTILS.randFloat(v9385.spread[0], v9385.spread[1]);
        var v9394 = p12009 + UTILS.randFloat(v9385.spread[0], v9385.spread[1]);
        this.add(p12005, p12006, p12007, {
          src: v9385.src || 0,
          xV: v9392 * Math.sin(v9393) * Math.cos(v9394),
          yV: v9392 * Math.sin(v9394),
          zV: v9392 * Math.cos(v9393) * Math.cos(v9394),
          blend: v9385.blending,
          grav: v9385.grav,
          dstVis: v9385.dstVis,
          colr: v9385.colr ? v9385.colr[UTILS.randInt(0, v9385.colr.length - 1)] : null,
          siz: UTILS.randFloat(v9385.scale[0], v9385.scale[1]),
          life: v9385.life ? UTILS.randInt(v9385.life[0], v9385.life[1]) : 0
        }, null, p12011);
      }
      if (v9385.hole) {
        this.add(p12005, p12006, p12007, {
          src: "1",
          blend: THREE.SubtractiveBlending,
          siz: UTILS.randFloat(0.4, 1),
          life: 4000
        }, null, p12011);
      }
    }
  };
  this.add = function (p12012, p12013, p12014, p12015, p12016, p12017) {
    v9386 = null;
    var v9395 = p12017 || RENDER.scene;
    for (var vLN01522 = 0; vLN01522 < this.particles.length; ++vLN01522) {
      if (!this.particles[vLN01522].visible && !this.particles[vLN01522].static && this.particles[vLN01522].scene.name == v9395.name) {
        v9386 = this.particles[vLN01522];
        break;
      }
    }
    if (!v9386) {
      v9386 = new THREE.Sprite();
      this.particles.push(v9386);
      v9386.scene = v9395;
      v9395.add(v9386);
    }
    this.setMaterial(v9386, p12015.src, p12015.blend || 0, p12015.src != "grass_0", p12015.colr);
    v9386.visible = true;
    v9386.init(p12012, p12013, p12014, p12015, p12016);
  };
  this.setMaterial = function (p12018, p12019, p12020, p12021, p12022) {
    p12018.material = RENDER.getMat("particles/" + p12019, {
      mat: THREE.SpriteMaterial,
      color: p12022 == null ? "#ffffff" : p12022,
      depthWrite: false,
      blending: p12020 || THREE.NormalBlending,
      rotation: p12021 ? vA522[UTILS.randInt(0, 2)] : 0
    });
  };
  this.physObj = function (p12023, p12024, p12025, p12026, p12027, p12028, p12029, p12030, p12031, p12032, p12033, p12034, p12035) {
    v9386 = null;
    var v9396;
    var v9397 = p12032 || vA521[p12030];
    for (var vLN01523 = 0; vLN01523 < this.physObjs.length; ++vLN01523) {
      v9396 = v9397 && v9397.s ? v9397.s : p12035 ? p12035.s : null;
      if (!this.physObjs[vLN01523].mesh.visible && this.physObjs[vLN01523].meshConf.src == v9396) {
        v9386 = this.physObjs[vLN01523];
        break;
      }
    }
    if (!v9386) {
      v9386 = new f1503(RENDER, p12035, v9397);
      this.physObjs.push(v9386);
      RENDER.scene.add(v9386.mesh);
    }
    v9386.sid = p12033 == null ? null : p12033;
    v9386.owid = p12034 || null;
    v9386.mesh.visible = true;
    v9386.init(p12023, p12024, p12025, p12026, p12027, p12028, v9397, p12031, p12035);
    if (p12029 && this.showTrails) {
      this.addTrail(v9386, p12029);
    }
  };
  this.disablePhys = function (p12036, p12037, p12038, p12039, p12040, p12041) {
    if (p12037) {
      for (var vLN01525 = 0; vLN01525 < this.physObjs.length; ++vLN01525) {
        if (this.physObjs[vLN01525].owid == p12036) {
          if (this.physObjs[vLN01525].lingerTime && p12038) {
            if (this.physObjs[vLN01525].mesh.children[0] && this.physObjs[vLN01525].mesh.children[0].stopAllClips) {
              this.physObjs[vLN01525].mesh.children[0].stopAllClips();
            }
            RENDER.moveMesh(this.physObjs[vLN01525].mesh, p12039, p12040, p12041);
            this.physObjs[vLN01525].mesh.lookAt(p12039 - this.physObjs[vLN01525].xS, p12040 - this.physObjs[vLN01525].yS, p12041 - this.physObjs[vLN01525].zS);
            this.physObjs[vLN01525].linger = this.physObjs[vLN01525].lingerTime;
          } else {
            this.physObjs[vLN01525].mesh.visible = false;
          }
        }
      }
    } else {
      for (var vLN01525 = 0; vLN01525 < this.physObjs.length; ++vLN01525) {
        if (this.physObjs[vLN01525].sid == p12036) {
          if (this.physObjs[vLN01525].lingerTime && p12038) {
            if (this.physObjs[vLN01525].mesh.children[0] && this.physObjs[vLN01525].mesh.children[0].stopAllClips) {
              this.physObjs[vLN01525].mesh.children[0].stopAllClips();
            }
            RENDER.moveMesh(this.physObjs[vLN01525].mesh, p12039, p12040, p12041);
            this.physObjs[vLN01525].mesh.lookAt(p12039 - this.physObjs[vLN01525].xS, p12040 - this.physObjs[vLN01525].yS, p12041 - this.physObjs[vLN01525].zS);
            this.physObjs[vLN01525].linger = this.physObjs[vLN01525].lingerTime;
          } else {
            this.physObjs[vLN01525].mesh.visible = false;
          }
        }
      }
    }
  };
  this.update = function (p12042, p12043) {
    if (p12043 && p12043.active) {
      for (var vLN01530 = 0; vLN01530 < this.areas.length; ++vLN01530) {
        if (this.areas[vLN01530].f) {
          this.areas[vLN01530].x = p12043.x;
          this.areas[vLN01530].y = p12043.y;
          this.areas[vLN01530].z = p12043.z;
        }
      }
    }
    for (var vLN01530 = 0; vLN01530 < this.ropes.length; ++vLN01530) {
      this.ropes[vLN01530].update();
    }
    for (var vLN01530 = 0; vLN01530 < this.trails.length; ++vLN01530) {
      this.trails[vLN01530].update(p12042);
    }
    for (var vLN01530 = 0; vLN01530 < this.particles.length; ++vLN01530) {
      this.particles[vLN01530].update(p12042, this.active, p12043, this.partDst);
    }
    for (var vLN01530 = 0; vLN01530 < this.physObjs.length; ++vLN01530) {
      this.physObjs[vLN01530].update(p12042);
    }
    this.ExplosionManager.update(p12042);
  };
  this.reset = function () {
    this.particles.length = 0;
    this.trails.length = 0;
    this.ropes.length = 0;
    this.physObjs.length = 0;
    this.areas.length = 0;
  };
  this.setTracerColor = function (p12044) {
    vA521[0].color = p12044;
  };
};